import React, { memo } from "react";
import { useStore } from "../../../stores";
import { observer } from "mobx-react";
import * as Yup from "yup";
import PopupForm from "app/common/Component/Popup/PopupForm";
import GlobitsTextField from "app/common/form/GlobitsTextField";
import GlobitsSelectInput from "app/common/form/GlobitsSelectInput";
import { ENTRY_TYPES } from "../../../common/LocalConst";
import { Grid } from "@material-ui/core";

function RevenueExpenditurePopup({ handleAfterSubmit }) {
  const {
    selectedRevenueExpenditure,
    openFormCreateOrEdit,
    handleClosePopup,
    saveRevenueExpenditure,
  } = useStore().managementStore.revenueExpenditureStore;

  const validationSchema = Yup.object({
    code: Yup.string()
      .nullable()
      .test(
        "required-code",
        "Chưa có mã loại thuộc tính!",
        (val) => !(!Boolean(val) || val?.trim() === "")
      ),
    name: Yup.string()
      .nullable()
      .test(
        "required-name",
        "Chưa có tên loại thuộc tính!",
        (val) => !(!Boolean(val) || val?.trim() === "")
      ),
  });

  return (
    <PopupForm
      size="sm"
      title="Loại khoản thu chi"
      open={openFormCreateOrEdit}
      handleClose={handleClosePopup}
      formik={{
        initialValues: selectedRevenueExpenditure,
        onSubmit: async (values, { setSubmitting }) => {
          let data = await saveRevenueExpenditure(values, { setSubmitting });
          if (handleAfterSubmit) {
            handleAfterSubmit(data);
          }
        },
        validationSchema,
      }}
    >
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <GlobitsTextField
            name="code"
            label="Mã loại khoản thu chi"
            required
            notDelay
          />
        </Grid>
        <Grid item xs={12}>
          <GlobitsTextField
            name="name"
            label="Tên loại khoản thu chi"
            required
            notDelay
          />
        </Grid>
        <Grid item xs={12}>
          <GlobitsSelectInput
            label={"Loại thu chi"}
            name={"entryType"}
            options={ENTRY_TYPES}
          />
        </Grid>
        <Grid item xs={12}>
          <GlobitsTextField
            label="Ghi chú"
            name="description"
            isTextArea
            minRows={3}
          />
        </Grid>
      </Grid>
    </PopupForm>
  );
}

export default memo(observer(RevenueExpenditurePopup));
